import React, { Component, Fragment } from 'react';
import { Nav, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { authActions } from '../../../common/redux/actions';
import Notification from "./Notification";
import { Role } from '../../../helpers';

class LoggedUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount(){
        
    }

    onLogout = () => {
        const { dispatch } = this.props;
        dispatch(authActions.logout());
    };

    render() {
        const { authentication } = this.props;
        const { user } = authentication && authentication.loggedIn && authentication.authentication;
        
        return (<Fragment>
            <Nav className="navbar-nav navbar-profile">
                {/* <Nav.Item as="li">
                    <NavLink className="nav-link" to="/messages">
                        <img src="/images/svg/Message.svg" alt="" className="img-fluid" width="30" />
                        <span className="badge badge-primary rounded-circle">1</span>
                    </NavLink>
                </Nav.Item> */}
                {(authentication && authentication.authentication) && <Notification />}
                <NavDropdown title={<>
                    <span>
                        <img src={(user && user.avatar) ? user.avatar : '/images/dummy-profile.png'} alt="" className="border rounded-circle mr-2" width="40" height="40" />
                    </span>
                    <span className="username">{user && user.name} ({user && user.role})</span>
                </>} className="profile-dropdown">
                    {(user && user.role === Role.User) && <>
                        <NavLink className="dropdown-item border-bottom-0" to="/user/dashboard">Dashboard</NavLink>
                        <NavLink className="dropdown-item border-bottom-0" to="/user/update-profile">My Profile</NavLink>
                        <NavLink className="dropdown-item border-bottom-0" to="/user/change-password">Change Password</NavLink>
                    </>}
                    {(user && user.role === Role.Tutor) && <>
                        <NavLink className="dropdown-item border-bottom-0" to="/tutor/dashboard">Dashboard</NavLink>
                        <NavLink className="dropdown-item border-bottom-0" to="/tutor/profile">My Profile</NavLink>
                        <NavLink className="dropdown-item border-bottom-0" to="/tutor/change-password">Change Password</NavLink>
                    </>}
                    <NavLink className="dropdown-item border-bottom-0" to="/home" onClick={this.onLogout}>Logout <small>({user && user.name})</small></NavLink>
                </NavDropdown>
            </Nav>
        </Fragment>);
    }
}

const authSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const proposalSelector = createSelector(
    state => state.proposals,
    proposals => proposals
);

const mapStateToProps = createSelector(
    authSelector, proposalSelector,
    (authentication, proposals) => ({
        authentication, proposals
    })
);

export default connect(mapStateToProps)(LoggedUser);
